/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { RELEASE_NOTES_URL } from 'utils/constants';

import * as R from 'ramda';
import { useUserRolePermissions } from 'hooks';

// Components
import SmallModuleButton from 'common/SmallModuleButton';

// icons
import SwiftLogo from 'assets/img/dashboard-swift-logo.svg';
import MagellanLogo from 'assets/img/dashboard-magellan-logo.svg';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import MediationIcon from '@mui/icons-material/Mediation';

import { hasAllRoles, hasAnyRoles, userRoles } from 'utils/currentUserRoles';
import packageJson from '../../../package.json';

const Dashboard = () => {
  const { currentAffiliate } = useUserRolePermissions();

  const menuItems = [
    {
      disabled: R.not(hasAnyRoles([userRoles.SHIPPER, userRoles.INVENTORY_OWNER])),
      icon: <MediationIcon fontSize="inherit" />,
      label: 'Batches',
      loading: R.isNil(currentAffiliate),
      to: hasAllRoles([userRoles.SHIPPER]) ? 'batches/batch' : 'batches/distribution',
    },
  ];

  const buttons = R.not(hasAllRoles([userRoles.SHIPPER]))
    ? menuItems
    : R.prepend(
        {
          disabled: false,
          icon: <TimerOutlinedIcon fontSize="inherit" />,
          label: 'Monthly Nominations',
          loading: R.isNil(currentAffiliate),
          to: 'monthly-nominations/nominated',
        },
        menuItems
      );

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: { xs: 'initial', sm: '100vh' },
        justifyContent: 'space-between',
        pb: 6,
        pt: 7,
        px: 2,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: '0.5',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Link to="../..">
          <img alt="Swift" src={SwiftLogo} />
        </Link>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {buttons.map(({ label, ...rest }) => (
          <SmallModuleButton key={label} label={label} {...rest} />
        ))}
      </Box>
      <Box
        sx={{
          alignItems: 'flex-end',
          display: 'flex',
          flex: '1',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Button
            href={RELEASE_NOTES_URL}
            sx={{
              mb: 'auto',
              mt: 2,
              mx: 'auto',
              padding: '2px 0',
              width: 56,
            }}
            target="_blank"
            variant="text"
          >
            Release Notes
          </Button>
          <img
            alt="Magellan Midstream Partners, L.P."
            src={MagellanLogo}
            style={{ marginBottom: '24px' }}
          />
          <Typography align="center" sx={{ mb: 3 }} variant="caption">
            Version {packageJson.version}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
